import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './AnimatedInsightsChart.css';

const AnimatedInsightsChart = ({ data, height = 300 }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!data || Object.keys(data).length === 0) return;

    // Sort data by count
    const sortedData = Object.entries(data).sort(([,a], [,b]) => b - a);
    const maxCount = Math.max(...Object.values(data));

    // Create chart HTML
    const generateBarsHTML = () => {
      return sortedData.map(([label, count]) => {
        const percentage = (count / maxCount) * 100;
        
        return `
          <div class="insight-bar-item">
            <div class="insight-bar-label">${label}</div>
            <div class="insight-bar-wrapper">
              <div class="insight-bar-fill" data-percentage="${percentage.toFixed(1)}">
                <div class="insight-bar-count">${count}</div>
              </div>
            </div>
          </div>
        `;
      }).join('');
    };

    if (chartRef.current) {
      chartRef.current.innerHTML = `
        <div class="insight-chart-container">
          <div class="insight-bar-container">
            ${generateBarsHTML()}
          </div>
        </div>
      `;

      // Initialize GSAP animations
      const initializeChart = () => {
        const bars = chartRef.current.querySelectorAll('.insight-bar-item');
        const fills = chartRef.current.querySelectorAll('.insight-bar-fill');
        
        // Animate bars appearing
        gsap.fromTo(bars, {
          opacity: 0,
          x: -30
        }, {
          opacity: 1,
          x: 0,
          duration: 0.5,
          stagger: 0.1,
          ease: "back.out(1.7)"
        });
        
        // Animate bar fills
        fills.forEach((fill, index) => {
          const percentage = fill.getAttribute('data-percentage');
          gsap.to(fill, {
            width: percentage + '%',
            duration: 0.8,
            delay: 0.1 + (index * 0.1),
            ease: "elastic.out(1, 0.5)"
          });
        });
        
        // Add hover effects
        setTimeout(() => {
          bars.forEach(item => {
            item.addEventListener('mouseenter', () => {
              gsap.to(item, {
                scale: 1.02,
                duration: 0.2,
                ease: "power2.out"
              });
            });
            
            item.addEventListener('mouseleave', () => {
              gsap.to(item, {
                scale: 1,
                duration: 0.2,
                ease: "power2.out"
              });
            });
          });
        }, 1500);
      };

      initializeChart();
    }
  }, [data, height]);

  return (
    <div 
      ref={chartRef}
      className="animated-insights-chart"
      style={{ height: height || '100%' }}
    >
      {!data || Object.keys(data).length === 0 ? (
        <div className="no-insights-data">No insights data available</div>
      ) : null}
    </div>
  );
};

export default AnimatedInsightsChart; 